import React from "react";

export default function BurgerMenu() {
    return (
        <div className="burger-menu">
            <div className="burger-icon-otr">
                <svg
                    className="burger-icon"
                    width="24"
                    height="24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.75 12h16.5M4 6h9M11 18h9"
                        stroke="#999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        </div>
    );
}
